<template>
  <div>
    <p>New Dashboard</p>
  </div>
</template>

<script>
export default {
  name: "DashboardIndex",
}
</script>